import { VStack } from '@chakra-ui/react';

export default function VStackColumn({ children, ...props }) {
  return <VStack {...props}>{children}</VStack>;
}
